import React from 'react';

import { inject, observer } from 'mobx-react';
import { Card } from '@sogei/react-web-components-catalog';


@inject("rootStore")
@observer
class Errore extends React.Component {

  constructor(props) {
    super(props);
  this.errorStore = this.props.rootStore.errorStore
  this.ripristina = this.ripristina.bind(this) 
  }

  componentDidMount() {
   }

   ripristina(actions) {
    
   this.errorStore.ripristina(values,() => {
      
    })
  }
   
  render() {
    const errorStore = this.props.rootStore.errorStore;
    
    const MessaggioErrore = ({ errorStore }) => {
      if (errorStore.error_code){
        if(errorStore.error_code===400){
          return(<>
          <div className="notification shadow alert alert-warning  d-flex" role="alert">
              <div className="alert-content">
          <h3 className="notification-title">Sessione invalida</h3>
                  <p>La sessione di lavoro risulta invalida.</p>
                  <p>Per proseguire nella navigazione è necessario effettuare un ripristino;
                   si verrà reindirizzati all'area autenticata.</p>
              
                  <button  onClick={() => errorStore.ripristina()} className="btn btn-primary" type="button" title="Ripristina">
                    <strong className="fas fa-syncmr-2"></strong>Ripristina
                  </button>
              </div>
          </div>
              </>)
          }
        else if (errorStore.error_code===403){
          return(<>
          <div className="notification shadow alert alert-danger d-flex" role="alert">
              <div className="alert-content">
            <h3 className="notification-title">Mancata autenticazione</h3>
                  <p>Non risulta un autenticazione per l'utente.</p>
                  <p>Per proseguire nella navigazione è necessario effettuare una nuova autenticazione.</p>
              
              </div>
          </div>
              </>)
          }
      else if (errorStore.error_code===401){
            return(<>
            <div className="notification shadow alert alert-danger d-flex" role="alert">
              <div className="alert-content">
            <h3 className="notification-title">Mancata autorizzazione</h3>
                  <p>L'utente non è autorizzato al servizio richiesto.</p>
              
              </div>
            </div>
              </>)
          }
      }
      else{
          return(<>
          <div className="notification shadow alert alert-danger d-flex" role="alert">
              <div className="alert-content">
          <h3 className="notification-title">Errore</h3>
                  <p>Si è verificato un errore sconosciuto</p>
              
              </div>
          </div>
              </>)
      }    
  }
  return (
      <>
     <br></br>
     <div id="error-msg" className="container-fluid ">
        
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-lg-6">
          <h2><strong className="fas fa-exclamation-triangle fa-2x mb-2 mb-md-0"></strong> Attenzione</h2>
          </div>
        </div>
         <MessaggioErrore errorStore={errorStore}></MessaggioErrore> 
       </div>
   
    </>
    
   
    );
  }
}

export default Errore;